export interface Rollouts {
    [key: string]: boolean;
}

// //////////////////////////////////
// PLEASE KEEP ALPHABETICAL ORDER
// //////////////////////////////////
export const ROLLOUTS = {
    CARIBOU_PORTFOLIO_ATTACHMENT_REPORT_ELIGIBILITY: 'caribou_portfolio_attachment_report_eligibility',
    CHEETAHS_GIG_PAGE_DATA_GQL: 'cheetahs_gig_page_data_gql',
    CHEETAHS_GIG_PAGE_DQA: 'cheetahs_gig_page_dqa',
    CHEETAHS_MOBILE_GIG_PAGE: 'cheetahs_mobile_gig_page',
    HAWKS_ADD_TIMEOUT_TO_ADDITIONAL_DATA: 'hawks_add_timeout_to_additional_data',
    HAWKS_DQA_INTEGRATION_FIRST_PHASE: 'hawks_dqa_integration_first_phase',
    MEERKATS_AI_SUMMARY: 'meerkats_ai_summary',
    MEERKATS_AI_SUMMARY_AB_TEST: 'meerkats_ai_summary_ab_test',
    MEERKATS_AI_SUMMARY_ALL_GIGS: 'meerkats_ai_summary_all_gigs',
    MEERKATS_AI_SUMMARY_BUYERS: 'meerkats_ai_summary_buyers',
    PIGLETS_ENABLE_PRICE_UPFRONT_DISPLAY: 'piglets_enable_price_upfront_display',
    PIGLETS_GIG_PAGE_PAYPAL_PAYLATER_MESSAGE: 'piglets_gig_page_paypal_paylater_message', // we cannot delete rollout until the contract with PayPal expires
    QUALAS_GIG_PAGE_WORK_SAMPLES: 'qualas_gig_page_work_samples',
};

export const KILL_SWITCH_ROLLOUTS = {
    HAWKS_INFRA_LOG_UNKNOWN_CRAWLERS_ON_GIG_PAGE: 'hawks_infra_log_unknown_crawlers_on_gig_page',
};
